import { ComponentProps, FC } from 'react';

import { Icon } from './Icon';

export const IconMakeModel: FC<ComponentProps<typeof Icon>> = (props) => (
  <Icon {...props} viewBox="0 0 24 24">
    <path d="M13.6 13h-3.2v1.2h3.2V13ZM6.4 13h2.2v1.2H6.4V13ZM17.6 13h-2.2v1.2h2.2V13Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.391 4.4a2.6 2.6 0 0 0-2.508 1.916L5.14 9.039l-1.306-.871-.666.998 1.523 1.016-.778 1.297A3.6 3.6 0 0 0 3.4 13.33V17.5a2.6 2.6 0 1 0 5.2 0v-.9h6.8v.9a2.6 2.6 0 1 0 5.2 0v-4.169a3.6 3.6 0 0 0-.513-1.852l-.778-1.297 1.523-1.016-.666-.998-1.342.895-.94-2.872a2.6 2.6 0 0 0-2.47-1.791H8.39Zm11.009 11v-2.069a2.4 2.4 0 0 0-.342-1.235l-.909-1.515a.605.605 0 0 1-.15.019H6a.605.605 0 0 1-.148-.019l-.91 1.515a2.4 2.4 0 0 0-.341 1.235V15.4h14.8Zm-2.656-8.835.928 2.835H6.285l.755-2.768A1.4 1.4 0 0 1 8.391 5.6h7.023a1.4 1.4 0 0 1 1.33.965ZM4.6 16.6v.9a1.4 1.4 0 1 0 2.8 0v-.9H4.6Zm14.8 0v.9a1.4 1.4 0 1 1-2.8 0v-.9h2.8Z"
    />
  </Icon>
);
